import {DataFetcher} from '@aboutyou/data-fetcher';
import {ProminentBannerSection as ProminentBannerSectionType} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import React from 'react';
import {useCanShowCoupons} from '../../../features/Coupons/useCanShowCoupons';
import {useProminentBannerSection} from '../useGetProductBulkSection';
import {
  ProminentBannerSectionView,
  ProminentBannerSectionViewProps,
} from './ProminentBannerSectionView';

export const ProminentBannerSection: React.FC<
  Omit<ProminentBannerSectionViewProps, 'isInMiniADPDialog'>
> = props => {
  return (
    <DataFetcher
      request={useProminentBannerSection()}
      Error={null}
      viewProps={props}
      View={ProminentBannerSectionViewComponent}
    />
  );
};

const ProminentBannerSectionViewComponent: React.FC<
  ProminentBannerSectionType &
    Omit<ProminentBannerSectionViewProps, 'isInMiniADPDialog'>
> = props => {
  const canShowCoupons = useCanShowCoupons();

  if (props.type?.$case === 'couponSlider' && !canShowCoupons) {
    return null;
  }

  return <ProminentBannerSectionView {...props} isInMiniADPDialog={false} />;
};
